
import React, { useState } from "react";
import { User } from "lucide-react";
import { useAuth } from "@/contexts/auth-context";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "@/components/ui/use-toast";

export function ProfileForm() {
  const { user } = useAuth();
  
  const [name, setName] = useState(user?.name || "");
  const [bio, setBio] = useState(user?.bio || "");
  const [githubUsername, setGithubUsername] = useState(user?.githubUsername || "");
  
  const handleProfileUpdate = () => {
    // In a real app, this would update the user's profile in the backend
    toast({
      title: "Profile Updated",
      description: "Your profile has been updated successfully.",
    });
  };
  
  return (
    <Card>
      <CardHeader>
        <CardTitle>Profile Information</CardTitle>
        <CardDescription>
          Update your account profile details
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <label className="text-sm font-medium" htmlFor="email">
            Email
          </label>
          <Input id="email" value={user?.email} disabled />
          <p className="text-xs text-muted-foreground">
            Your email cannot be changed
          </p>
        </div>
        
        <div className="space-y-2">
          <label className="text-sm font-medium" htmlFor="name">
            Name
          </label>
          <Input 
            id="name" 
            value={name} 
            onChange={(e) => setName(e.target.value)} 
          />
        </div>
        
        <div className="space-y-2">
          <label className="text-sm font-medium" htmlFor="bio">
            Bio
          </label>
          <Input 
            id="bio" 
            value={bio} 
            onChange={(e) => setBio(e.target.value)} 
          />
        </div>
        
        <div className="space-y-2">
          <label className="text-sm font-medium" htmlFor="githubUsername">
            GitHub Username
          </label>
          <Input 
            id="githubUsername" 
            value={githubUsername} 
            onChange={(e) => setGithubUsername(e.target.value)} 
          />
        </div>
        
        <div className="space-y-2">
          <label className="text-sm font-medium">
            Account Type
          </label>
          <div className="capitalize bg-muted px-3 py-2 rounded text-sm">
            {user?.profileType}
          </div>
        </div>
      </CardContent>
      <CardFooter>
        <Button onClick={handleProfileUpdate}>
          Save Changes
        </Button>
      </CardFooter>
    </Card>
  );
}
